import {useTranslation} from 'react-i18next';
import {FormLabel} from '@mui/material';
import UserSettingContent from '../../../../components/header/agyleMenu/settingsComponents/userSettingContent';

const DevicesTab = () => {
  const { t } = useTranslation();

  const getBrand = (data) => {
    if (data && data.length > 0) {
      let text = '';
      data.forEach(b => {
        text += `Brand: ${b.brand}, Version: ${b.version} | `;
      });
      return text;
    }
    return 'No data detected!';
  };

  return (
      <UserSettingContent title={t('Information about devices')}>
        <div style={{fontWeight: 'bold'}}>
          {t('Device 1')}
        </div>

        <div style={{marginBottom: 15}}>
          <FormLabel>
            userAgent
          </FormLabel>

          <div>
            {navigator?.userAgent || 'No data detected!'}
          </div>
        </div>

        <div style={{marginBottom: 15}}>
          <FormLabel>
            userAgentData
          </FormLabel>

          <div>
            <div>
              {t('Mobile')}: {navigator?.userAgentData?.mobile ? 'True' : 'False'}
            </div>

            <div>
              {t('Platform')}: {navigator?.userAgentData?.platform || 'No data detected!'}
            </div>

            <div>
              {t('Brands')}: {getBrand(navigator?.userAgentData?.brands)}
            </div>
          </div>
        </div>

        <div>
          <FormLabel>
            Screen Size
          </FormLabel>

          <div>
            <div>
              {t('Width')}: {window?.innerWidth}
            </div>

            <div>
              {t('Height')}: {window?.innerHeight}
            </div>
          </div>
        </div>
      </UserSettingContent>
  )
}

export default DevicesTab;